$(window).on("load", function () {
  setTimeout(function () {
    $(".pageLoadAnimation").addClass("pageLoadAnimation-active");
    $(".pageLoadAnimation_navigation").addClass("pageLoadAnimation_navigation-active");
  }, 200);
});

$(function () {
  // ページ遷移アニメーション
  // aタグの #（アンカーリンク） と targetが設定されたリンク を拒否
  // aタグに pageLoadAnimationDisabled クラスの追加で上記以外も拒否
  $('a:not([href^="#"]):not([target]):not(.pageLoadAnimationDisabled)').on("click", function (e) {
    e.preventDefault();
    const url = $(this).attr("href");
    if (url !== "") {
      if ($(".header_navigation").hasClass("header_navigation-active")) {
        $(".header_menuButton").removeClass("header_menuButton-active");
        $(".header_navigation").removeClass("header_navigation-active");
      }
      $(".pageLoadAnimation_navigation").removeClass("pageLoadAnimation_navigation-active");
      setTimeout(function () {
        $(".pageLoadAnimation").removeClass("pageLoadAnimation-active");
      }, 800);
      setTimeout(function () {
        window.location = url;
      }, 1600);
    }
    return false;
  });
});

$(function () {
  // アンカーリンクのスムーススクロール
  $('a[href^="#"]').on("click", function () {
    const adjust = 0,
      speed = 600,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href),
      position = target.offset().top + adjust;

    // Header Menu SP
    if ($(".header_navigation").hasClass("header_navigation-active")) {
      $(".header_menuButton").removeClass("header_menuButton-active");
      $(".header_navigation").removeClass("header_navigation-active");
    }

    // Top Menu Active
    if (position === 0) {
      setTimeout(function () {
        $(".header_navigation_menu_list").removeClass("header_navigation_menu_list-active");
        $("#navigation-top").addClass("header_navigation_menu_list-active");
      }, 600);
    }

    // Header Menu PC
    $(".header_navigation_menu_list").each(function () {
      $(this).removeClass("header_navigation_menu_list-active");
    });
    if ($(this).hasClass("header_navigation_menu_list_inner")) {
      $(this).parents(".header_navigation_menu_list").addClass("header_navigation_menu_list-active");
    }

    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});
